// removed by extract-text-webpack-plugin
module.exports = {"main_right_content":"components-tjcx-bdtjcx-jxBdtjcx-index-main_right_content-1Ihva","table":"components-tjcx-bdtjcx-jxBdtjcx-index-table-1PYkT"};


//////////////////
// WEBPACK FOOTER
// ./components/tjcx/bdtjcx/jxBdtjcx/index.css
// module id = 316
// module chunks = 0